<template>
    <DashboardEditSection class="SubscriptionForm" title="Billing">
        <h2>Payment methods</h2>
        <ManageCreditCards/>

        <h2>Your plan</h2>
        <BillingPlan :drivers="5"/>
    </DashboardEditSection>
</template>


<script>
import DashboardEditSection from '@/components/DashboardEditSection';
import ManageCreditCards from './ManageCreditCards';
import BillingPlan from './BillingPlan';

export default {
    name: 'SubscriptionForm',

    components: { DashboardEditSection, ManageCreditCards, BillingPlan },
};
</script>
